import { stringify } from "querystring";
import axiosInstance from "./axiosInstance";
import { AxiosResponse } from "axios";
import { DeleteEmployeeResponse } from "../Interface/Employee";

export const fetchEmployees = async (filters: Record<string, string>| null = null) => {
  try {
    console.log(filters)
    const response = await axiosInstance.get("/employees" ,{
      params: filters ?? undefined, 
    });
    console.log(response.data)
    return response.data;
    
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};

export const deleteEmployee = async (id: number): Promise<AxiosResponse<DeleteEmployeeResponse>> => {
  try {
    const response = await axiosInstance.delete<DeleteEmployeeResponse>(`/Employee/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting employee:", error);
    throw error;
  }
};


export const fetchGetProjects = async (filters: Record<string, string> | null = null) => {
  try {
    const response = await axiosInstance.get("/Projects", {
      params: filters ?? undefined,
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};

export const fetchEmployeeById = async (employeeId: number | string) => {
  try {
    const response = await axiosInstance.get(`/Employee/${employeeId}`);
    const result = response.data?.data;
    return Array.isArray(result) && result.length > 0 ? result[0] : null;
  } catch (error) {
    console.error("Error fetching employee by ID:", error);
    throw error;
  }
};

export const createEmployee = async (newEmployee: any) => {
  try {
    const response = await axiosInstance.post("/CreateEmployee", newEmployee);
    return response.data;
  } catch (error) {
    console.error("Error creating employee:", error);
    throw error;
  }
};

export const updateEmployee = async (updatedEmployee: any) => {
  try {
    const response = await axiosInstance.put("/UpdateEmployee", updatedEmployee);
    return response.data;
  } catch (error) {
    console.error("Error updating employee mapping:", error);
    throw error;
  }
};
